
import Path from "../../../assets/outline/Path.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PathIcon({ className, dataTestid = "PathIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Path data-testid={dataTestid} className={classes} {...rest} />
  );
}
